export default {
  SECTION_WIDGET_IMAGE: {
    container: {
      cellWidth: {
        100: {
          allow: true,
          item: 1,
        },
        66.67: {
          allow: true,
          item: 1,
        },
        58.33: {
          allow: true,
          item: 1,
        },
        50: {
          allow: true,
          item: 1,
        },
        41.67: {
          allow: true,
          item: 1,
        },
        33.33: {
          allow: true,
          item: 1,
        },
        25: {
          allow: true,
          item: 1,
        },
        20: {
          allow: true,
          item: 1,
        },
        16.66: {
          allow: true,
          item: 1,
        },
      },
    },
    fluid: {
      cellWidth: {
        100: {
          allow: true,
          item: 1,
        },
        66.67: {
          allow: true,
          item: 1,
        },
        58.33: {
          allow: true,
          item: 1,
        },
        50: {
          allow: true,
          item: 1,
        },
        41.67: {
          allow: true,
          item: 1,
        },
        33.33: {
          allow: true,
          item: 1,
        },
        25: {
          allow: true,
          item: 1,
        },
        20: {
          allow: true,
          item: 1,
        },
        16.66: {
          allow: true,
          item: 1,
        },
      },
    },
  },
};
